(() => {
  'use strict';
  const dayMS = 86400000;
  const iso = date => date.toISOString().slice(0, 10);
  const utcDate = value => new Date(`${value}T12:00:00Z`);
  function initBooking(scope = document) {
    scope.querySelectorAll('[data-bmf-booking]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.closest('form');
      const input = root.querySelector('[data-bmf-date]');
      const time = root.querySelector('[data-bmf-time]');
      const zone = root.querySelector('[data-bmf-zone]');
      const calendar = root.querySelector('[data-bmf-calendar]');
      const days = root.querySelector('[data-bmf-days]');
      const error = root.querySelector('[data-bmf-error]');
      const locale = root.dataset.locale || 'cs';
      const serviceSelect = root.querySelector('[data-bmf-service]');
      const locationSelect = root.querySelector('[data-bmf-location]');
      const locationField = root.querySelector('[data-bmf-location-field]');
      const serviceMap = {training:'Online 1-on-1 training',plan:'Personalized plan',support:'Check-in and support','in-person':'In-person training'};
      const locationMap = {domazlice:'Domažlice',bor:'Bor u Tachova'};
      const hasFormErrors = Boolean(form.querySelector('[role="alert"]:not([data-bmf-error])'));
      let onlineZone;
      let previousInPerson = false;
      let minDate, maxDate, view;
      if (!hasFormErrors) zone.value = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Prague';
      onlineZone = zone.value;
      const getNow = () => {
        const parts = new Intl.DateTimeFormat('en-CA', {timeZone: zone.value.trim(), year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', hourCycle:'h23'}).formatToParts(new Date());
        const v = Object.fromEntries(parts.map(p => [p.type, p.value]));
        return {date: `${v.year}-${v.month}-${v.day}`, time: `${v.hour}:${v.minute}`};
      };
      const validateZone = () => {
        try { getNow(); zone.setCustomValidity(''); return true; }
        catch { zone.setCustomValidity(root.dataset.invalidZone); return false; }
      };
      const limits = () => {
        if (!validateZone()) return false;
        minDate = getNow().date;
        maxDate = iso(new Date(utcDate(minDate).getTime() + 90 * dayMS));
        input.min = minDate; input.max = maxDate;
        if (!view) view = utcDate(input.value || minDate);
        return true;
      };
      const fullDate = value => new Intl.DateTimeFormat(locale, {timeZone:'UTC', dateStyle:'full'}).format(utcDate(value));
      function render(focusDay) {
        if (!limits()) return;
        view = new Date(Date.UTC(view.getUTCFullYear(), view.getUTCMonth(), 1, 12));
        const year = view.getUTCFullYear(), month = view.getUTCMonth();
        root.querySelector('[data-bmf-month-label]').textContent = new Intl.DateTimeFormat(locale, {timeZone:'UTC', month:'long', year:'numeric'}).format(view);
        const count = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
        const offset = (view.getUTCDay() + 6) % 7;
        days.replaceChildren();
        for (let i=0; i<offset; i++) { const spacer=document.createElement('span'); spacer.setAttribute('aria-hidden','true'); days.append(spacer); }
        for (let n=1; n<=count; n++) {
          const value = iso(new Date(Date.UTC(year, month, n, 12)));
          const button = document.createElement('button');
          button.type='button'; button.textContent=String(n); button.dataset.date=value;
          button.setAttribute('aria-label', fullDate(value));
          button.setAttribute('aria-pressed', String(value===input.value));
          if(value===minDate) button.setAttribute('aria-current','date');
          button.disabled=value<minDate || value>maxDate;
          days.append(button);
        }
        root.querySelector('[data-bmf-month="-1"]').disabled = iso(view).slice(0,7)<=minDate.slice(0,7);
        root.querySelector('[data-bmf-month="1"]').disabled = iso(view).slice(0,7)>=maxDate.slice(0,7);
        if(input.value) root.querySelector('[data-bmf-selected]').textContent = `${root.dataset.selectedLabel} ${fullDate(input.value)}`;
        if(focusDay) days.querySelector(`[data-date="${focusDay}"]`)?.focus();
      }
      function validateDate() {
        input.setCustomValidity(''); time.setCustomValidity('');
        if (!limits()) return false;
        const now = getNow();
        if (input.value && (input.value < minDate || input.value > maxDate)) input.setCustomValidity(root.dataset.invalidDate);
        if (input.value === now.date && time.value && time.value <= now.time) time.setCustomValidity(root.dataset.invalidDate);
        return input.validity.valid && time.validity.valid;
      }
      function updateService() {
        const inPerson = serviceSelect.value === 'In-person training' && Boolean(locationSelect);
        if (locationSelect) {
          locationSelect.required = inPerson;
          locationSelect.disabled = !inPerson;
          locationField.hidden = !inPerson;
          root.querySelector('[data-bmf-location-required]').hidden = !inPerson;
          if (!inPerson) locationSelect.value = '';
        }
        if (inPerson) {
          if (!previousInPerson) onlineZone = zone.value;
          zone.value = 'Europe/Prague';
        } else if (previousInPerson) zone.value = onlineZone;
        zone.readOnly = inPerson;
        root.querySelector('[data-bmf-online-zone-help]').hidden = inPerson;
        root.querySelector('[data-bmf-prague-zone-help]').hidden = !inPerson;
        previousInPerson = inPerson;
        validateZone();
        validateDate();
        if (limits()) {view = utcDate(input.value || minDate);render();}
      }
      function applyRequest(params) {
        const value = serviceMap[params.get('service')];
        if (!value || !Array.from(serviceSelect.options).some(option => option.value === value)) return false;
        serviceSelect.value = value;
        updateService();
        if (locationSelect && value === 'In-person training') locationSelect.value = locationMap[params.get('location')] || '';
        return true;
      }
      serviceSelect.addEventListener('change', updateService);
      const weekdays = root.querySelector('[data-bmf-weekdays]');
      for(let i=0;i<7;i++) { const span=document.createElement('span');span.textContent=new Intl.DateTimeFormat(locale,{weekday:'short',timeZone:'UTC'}).format(new Date(Date.UTC(2026,0,5+i)));weekdays.append(span); }
      root.querySelectorAll('[data-bmf-month]').forEach(button => button.addEventListener('click', () => {view=new Date(Date.UTC(view.getUTCFullYear(),view.getUTCMonth()+Number(button.dataset.bmfMonth),1,12));render();}));
      days.addEventListener('click', event => {const button=event.target.closest('[data-date]');if(!button || button.disabled)return;input.value=button.dataset.date;validateDate();render(input.value);});
      days.addEventListener('keydown', event => {
        const button=event.target.closest('[data-date]'); const moves={ArrowLeft:-1,ArrowRight:1,ArrowUp:-7,ArrowDown:7};
        if(!button || !(event.key in moves))return;
        event.preventDefault(); const value=iso(new Date(utcDate(button.dataset.date).getTime()+moves[event.key]*dayMS));
        if(value<minDate || value>maxDate)return;view=utcDate(value);render(value);
      });
      input.addEventListener('change',()=>{if(input.value)view=utcDate(input.value);validateDate();render();});
      time.addEventListener('input',validateDate);
      zone.addEventListener('input',()=>{validateZone();validateDate();});
      zone.addEventListener('change',()=>{if(limits()){view=utcDate(input.value || minDate);render();}});
      form.addEventListener('submit', event => {
        if (serviceSelect.value === 'In-person training' && locationSelect) zone.value = 'Europe/Prague';
        const valid=validateZone() && validateDate();
        error.hidden=true;
        if(!valid || !form.checkValidity()) {event.preventDefault();error.textContent=zone.validationMessage || input.validationMessage || time.validationMessage;error.hidden=!error.textContent;form.reportValidity();}
      });
      updateService();
      if (!hasFormErrors) applyRequest(new URLSearchParams(location.search));
      document.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !root.isConnected) return;
        const link = event.target.closest('a[href]');
        if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '') || url.hash !== '#booking') return;
        if (!applyRequest(url.searchParams)) return;
        event.preventDefault();
        history.replaceState(history.state, '', url);
        const target = root.closest('.bmf-booking');
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
        input.focus({preventScroll:true});
      });
      if(limits()){render();calendar.hidden=false;}
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initBooking()); else initBooking();
  document.addEventListener('shopify:section:load',event=>initBooking(event.target));
})();

